import * as $ from 'jquery';
import {debounce} from "throttle-debounce";
import TranslationsService from '../services/translationsService';
import {RegionHelper} from "../angular-modules/common/helpers/region.helper";

namespace PFF.controllers.partsAndSupport {
	let translationsService = TranslationsService.getInstance();
	let translationStrings = JSON.parse($("#translations").html());
	let saytStrings = JSON.parse($("#sayt-translations").html());
	translationsService.init(translationStrings);
	translationsService.init(saytStrings);

	let lastSearchTerm = '';

	function trackViewAllResults(query){
		window.dataLayer = window.dataLayer || [];
		window.dataLayer.push({
			'searchText' : query, //Insert the text that was searched
			'event' : 'support_searched_viewall'
		});
	}

	function supportSearchApi(query){
		let $viewAll = $('.js-sayt-view-all');
		let $viewAllButton = $('.js-sayt-view-all-button');
		let $alertDanger = $('.js-alert-danger');
		let $dropdown = $('.js-sayt-dropdown');

		$.get("/api/pff/support-search?query="+query)
			.done(function (result) {
				$('.js-sayt-menu').empty();

				if (result) {
					let searchResult = result.data;
					$viewAll.removeClass('hidden');

					if(searchResult.length) {
						$dropdown.removeClass('hidden');
						let searchPrefix = `${translationsService.translate('Forms.Search')}`;

						//viewall search button tracking for GA
						$('body').off('click.viewall').on('click.viewall', '.js-sayt-view-all-button', function(){
							trackViewAllResults(query);
						});

						//set our View All Link to take you to the approppriate area on the search results pages
						$viewAllButton.attr('href', `${RegionHelper.localizedUrl('')}/${searchPrefix}?FilterCriteria.Query=${query}&FilterCriteria.Tab=support` );

						//Loop through each product in the results and return the values
						$.each(searchResult, function () {
							var videoType = this.ContentTypeId == "Videos" ? "js-video" : "";
							var urlSelect = this.ContentTypeId == "Videos" ? "https://www.youtube.com/watch?v=" + this.Url : this.Url;
							
							$(`<li class="v-support__sayt-menu-item">
								<a href="${urlSelect}" class="v-support__sayt-menu-link" target="_blank">${this._HighlightResult.Title.Value}</a>
							</li>`).appendTo('.js-sayt-menu');
						});

						$viewAllButton.removeClass('hidden');
					} else {
						$(`<li class="v-support__sayt-menu-item state-no-results">
							<em>${translationsService.translate('No')} <strong>${translationsService.translate('Support')} </strong> ${translationsService.translate('ResultsFor')} "${query}"</em>
						</li>`).appendTo('.js-sayt-menu');

						//hide the view all link if there are no results
						$viewAllButton.addClass('hidden');
					}
				} else {
					$alertDanger
						.removeClass('hidden')
						.find('.js-alert-text')
						.text(translationsService.translate('NoData'));

					window.scrollTo(0, 0);
				}
			})
			.fail(function (response) {
				console.log('fail:' + response);
			});
	}

	export function init() {
		var $saytInput = $('.js-sayt-input');
		var $saytButton = $('.js-sayt-button');
		var $submit = $('.js-sayt-submit');
		let $dropdown = $('.js-sayt-dropdown');
		let $formTrigger = $('.js-sayt-trigger');
		let $partSearchForm = $('.js-part-search');
		let $partSearchInput = $('.js-part-search-input');

		function openMenu() {
			$dropdown.removeClass('hidden');
			$saytButton.addClass('state-open');
		}

		//GA TRACKING
		$partSearchInput.keypress(function(event){
			var keycode = (event.keyCode ? event.keyCode : event.which);

			if(keycode == '13'){
				trackPartSearch($partSearchInput.val());
			}
		});

		var simulateClick = function (elem) {
			// Create our event (with options)
			var evt = new MouseEvent('click', {
				bubbles: true,
				cancelable: true,
				view: window
			});
			// If cancelled, don't dispatch our event
			var canceled = !elem.dispatchEvent(evt);
		};

		function closeMenu() {
			$dropdown.addClass('hidden');
			$saytButton.removeClass('state-open');
		}

		$saytInput.on('keyup', function (evt) {
			if (evt.keyCode != 13) { //enter button
				let inputValue = $(this).val();
				let slugValue = inputValue.replace(' ', '+');
				let searchPrefix = `${translationsService.translate('Forms.Search')}`;
				if (inputValue.length) {
					openMenu();
					$formTrigger.attr('href', `${RegionHelper.localizedUrl('')}/${searchPrefix}?FilterCriteria.Query=${slugValue}&FilterCriteria.Tab=support`);
					supportSearchApi(inputValue);
				} else {
					$formTrigger.attr('href', `${RegionHelper.localizedUrl('')}/${searchPrefix}?FilterCriteria.Query=${slugValue}&FilterCriteria.Tab=support`);
					closeMenu();
				}

				lastSearchTerm = inputValue;
			} else {
				console.log('it is enter');
				setTimeout(function(){
					simulateClick(document.querySelector('.js-sayt-trigger'));
				}, 25);
			}
		});

		$('body').on('click.saytdropdown', '.js-sayt-dropdown a:not(.js-sayt-view-all-button)', function(){
			let $this = $(this);
			trackSupportSearchSubmit($this.text().trim());
		});

		$saytButton.on('click', function(e){
			if ( !$(this).hasClass('state-open') ) {
				closeMenu();
				setTimeout(function(){
					trackSupportSearchSubmit($saytInput.val());
					simulateClick(document.querySelector('.js-sayt-trigger'));
				}, 25);
			} else {
				closeMenu();
			}
		});

		//METRICS TRACKING
		function trackSupportSearchSubmit(inputText){
			window.dataLayer = window.dataLayer || [];
			window.dataLayer.push({
				'searchText' : inputText, //Insert the text that was searched
				'event' : 'support_searched'
			});
		}

		$submit.on('submit', function(e){
			e.preventDefault();
		});

		//on press enter track search item
		$saytInput.keypress(function(event){
			var keycode = (event.keyCode ? event.keyCode : event.which);

			if(keycode == '13'){
				trackSupportSearchSubmit($saytInput.val());
			}
		});

		//METRICS TRACKING
		function trackPartSearch(inputText){
			window.dataLayer = window.dataLayer || [];
			window.dataLayer.push({
				'searchText' : inputText, //Insert the model number that was searched
				'event' : 'modelnum_searched_parts'
			});
			console.log(window.dataLayer.event);
		}

		$partSearchForm.on('submit', function(){
			let inputValue = $partSearchInput.val();
			trackPartSearch(inputValue);
		});
	}
}

PFF.controllers.partsAndSupport.init();



// WEBPACK FOOTER //
// ./js/PFF/controllers/partsAndSupport.ts